import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = {
  key: 0,
  class: "s20_mobile container-full-1 my-5"
}
const _hoisted_4 = { class: "grid2 grid-row-gap-0" }
const _hoisted_5 = { class: "card-check lg single" }
const _hoisted_6 = {
  class: "form-check-label",
  for: "gerant_type_new"
}
const _hoisted_7 = { class: "card-check-text" }
const _hoisted_8 = { class: "card-check lg single" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "gerant_type_existing"
}
const _hoisted_10 = { class: "card-check-text" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "form-field-floating active my-5" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "text-red"
}
const _hoisted_15 = {
  key: 1,
  class: "text-grey-500 text-sm mt-2"
}
const _hoisted_16 = {
  key: 2,
  class: "s20 form"
}
const _hoisted_17 = { class: "container-full-1" }
const _hoisted_18 = { class: "form-field-floating reactive active my-5" }
const _hoisted_19 = {
  key: 0,
  class: "text-red"
}
const _hoisted_20 = { class: "form-field-floating reactive my-5" }
const _hoisted_21 = {
  key: 1,
  class: "text-red"
}
const _hoisted_22 = { class: "form-field-split my-5" }
const _hoisted_23 = { class: "form-field-floating reactive half" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "form-field-floating reactive half" }
const _hoisted_26 = {
  key: 2,
  class: "text-red"
}
const _hoisted_27 = {
  key: 3,
  class: "text-red"
}
const _hoisted_28 = { class: "container-full-1" }
const _hoisted_29 = { class: "form-field-split active my-5" }
const _hoisted_30 = { class: "form-field-floating reactive half" }
const _hoisted_31 = {
  key: 0,
  class: "text-red"
}
const _hoisted_32 = { class: "s10_mobile container-full-2" }
const _hoisted_33 = {
  key: 0,
  class: "text-red"
}
const _hoisted_34 = { class: "flex gap-2" }

import { ref, reactive, watch, inject, Ref, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import moment from 'moment';
    import axios from 'axios';
    import { useToastStore } from '@/stores/toast.store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementGerant',
  setup(__props) {

    const route = useRoute();
    const toastStore = useToastStore();
    const errorMessage = ref('');
    const loading = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const startupFormDatas = reactive({
        pays: [] as any[],
        users: [] as any[]
    });
    const gerant = ref(null as any);
    const membres = ref([] as any[]);
    const gerantType = ref<'new' | 'existing'>('new'); // Type de gérant : 'new' ou 'existing'
    const isFormValid = ref(false);
    const formData = reactive({
        nom: null as string | null,
        prenom: null as string | null,
        date_naissance: null as string | null,
        age: 0,
        telephone: null as string | null,
        email: null as string | null,
        gerant_id: null as number | null // ID de l'utilisateur existant à associer
    });
    const errors = reactive({
        nom: "",
        prenom: "",
        date_naissance: "",
        age: "",
        telephone: "",
        email: "",
        gerant_id: ""
    });

    function recomputeAge() {
        if (!formData.date_naissance) { formData.age = 0; return; }
        const birthDate = moment(formData.date_naissance);
        if (birthDate.isValid()) formData.age = moment().diff(birthDate, 'years');
    }

    function onDateNaissanceChange(e: Event) {
        formData.date_naissance = (e.target as HTMLInputElement).value;
        recomputeAge();
    }

    // Fallback : watcher pour binding programmatique
    watch(() => formData.date_naissance, () => recomputeAge());

    onMounted(() => {
        const dbMembres = (route.meta.item as any).membres as any[];
        if (dbMembres) {
            membres.value = dbMembres;
        }
        const dbGerant = (route.meta.item as any).gerant as any;
        if (dbGerant) {
            _setGerant(dbGerant);
        }
    })

    function _setGerant(dbGerant: any) {
        gerant.value = dbGerant;
        Object.assign(formData, {
            nom: dbGerant.nom,
            prenom: dbGerant.prenom,
            date_naissance: moment(dbGerant.date_naissance).format('YYYY-MM-DD'),
            age: dbGerant.age,
            telephone: dbGerant.telephone,
            email: dbGerant.email,
            gerant_id: dbGerant.gerant_id
        });
        gerantType.value = 'new';
    }

    function validate() {
        let isValid = true;
        errors.gerant_id = '';
        errors.nom = '';
        errors.prenom = '';
        errors.date_naissance = '';
        errors.age = '';
        errors.telephone = '';
        errors.email = '';

        if (gerantType.value === 'existing') {
            // Si on sélectionne un utilisateur existant, vérifier que gerant_id est défini
            if (!formData.gerant_id) {
                errors.gerant_id = "Veuillez sélectionner un utilisateur existant";
                isValid = false;
            }
        } else {
            errors.nom = '';
            if (!formData.nom) {
                errors.nom ="Le nom est requis";
                isValid = false;
            }

            errors.prenom = '';
            if (!formData.prenom) {
                errors.prenom ="Le prénom est requis";
                isValid = false;
            }

            errors.date_naissance = '';
            if (!formData.date_naissance) {
                errors.date_naissance ="La date de naissance est requise";
                isValid = false;
            } else {
                const birthDate = moment(formData.date_naissance);
                if (!birthDate.isValid()) {
                    errors.date_naissance ="Le format de la date de naissance est invalide";
                    isValid = false;
                }
            }

            errors.age = '';
            if (!formData.age) {
                errors.age ="L'âge est requis";
                isValid = false;
            } else if (isNaN(formData.age) || formData.age <= 0) {
                errors.age ="Le format de l'âge est invalide";
                isValid = false;
            }

            errors.telephone = '';
            if (!formData.telephone) {
                errors.telephone ="Le téléphone est requis";
                isValid = false;
            }

            errors.email = '';
            if (!formData.email) {
                errors.email ="L'email est requis";
                isValid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
                errors.email = "Le format de l'email est invalide";
                isValid = false;
            }
        }

        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                gerantType: gerantType.value,
                nom: formData.nom,
                prenom: formData.prenom,
                date_naissance: formData.date_naissance,
                age: formData.age,
                telephone: formData.telephone,
                email: formData.email,
                gerant_id: formData.gerant_id,
            };

            const response = await axios.post(`/backoffice/collectivites/${collectivite!.value.id}/update_gerant`, formToUpload);
            if (response.data.gerant) {
                _setGerant(response.data.gerant);
            }
            toastStore.success("Modifications effectuées");
        } catch(error: any) {
            console.error(error);
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, [
        _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-info-perso.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Gérant ")
        ])
      ], -1)),
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
      (!gerant.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "font-medium mb-3 block" }, [
              _createTextVNode("Type de gérant "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input left",
                      type: "radio",
                      name: "gerant_type",
                      id: "gerant_type_new",
                      value: "new",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((gerantType).value = $event))
                    }, null, 512), [
                      [_vModelRadio, gerantType.value]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "font-semibold mt-1 mb-2 align-right" }, "Créer un nouveau gérant", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input left",
                      type: "radio",
                      name: "gerant_type",
                      id: "gerant_type_existing",
                      value: "existing",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((gerantType).value = $event))
                    }, null, 512), [
                      [_vModelRadio, gerantType.value]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "font-semibold mt-1 mb-2 align-right" }, "Utiliser un utilisateur existant", -1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (gerantType.value === 'existing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                name: "gerant_id",
                id: "gerant_id",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.gerant_id) = $event))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("option", {
                  value: null,
                  selected: ""
                }, "Sélectionnez un utilisateur", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membres.value, (user, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: user.id,
                    key: 'user_' + index
                  }, _toDisplayString(user.fullname) + " - " + _toDisplayString(user.email) + " " + _toDisplayString(user.fonction ? '(' + user.fonction + ')' : ''), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.gerant_id]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "gerant_id" }, [
                _createTextVNode("Utilisateur existant "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ]),
            (!!errors.gerant_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(errors.gerant_id), 1))
              : _createCommentVNode("", true),
            (startupFormDatas.users.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Aucun utilisateur disponible. Créez d'abord un utilisateur ou choisissez \"Créer un nouveau gérant\". "))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("form", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
                _createElementVNode("img", {
                  src: "/icons/icon-info-perso.svg",
                  class: "size-base",
                  alt: ""
                }),
                _createTextVNode(" Informations personnelles ")
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.nom) = $event)),
                  name: "nom",
                  id: "nom",
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, formData.nom]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("label", { for: "nom" }, [
                  _createTextVNode("Nom "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (!!errors['nom'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(errors['nom']), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.prenom) = $event)),
                  name: "prenom",
                  id: "prenom",
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, formData.prenom]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "prenom" }, [
                  _createTextVNode("Prénoms "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (!!errors['prenom'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(errors['prenom']), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    value: formData.date_naissance,
                    onInput: onDateNaissanceChange,
                    onChange: onDateNaissanceChange,
                    name: "date_naissance",
                    id: "date_naissance",
                    placeholder: ""
                  }, null, 40, _hoisted_24),
                  _cache[16] || (_cache[16] = _createElementVNode("label", { for: "date_naissance" }, [
                    _createTextVNode("Date de naissance "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "hr" }, null, -1)),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.age) = $event)),
                    name: "age",
                    id: "age",
                    placeholder: "",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, formData.age]
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("label", { for: "age" }, [
                    _createTextVNode("Age "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ])
              ]),
              (!!errors['date_naissance'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(errors['date_naissance']), 1))
                : _createCommentVNode("", true),
              (!!errors['age'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errors['age']), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_custom_phone_input, {
                  modelValue: formData.telephone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.telephone) = $event)),
                  id: "telephone",
                  classesNames: "half"
                }, null, 8, ["modelValue"]),
                _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "hr" }, null, -1)),
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.email) = $event)),
                    name: "email",
                    id: "email",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, formData.email]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("label", { for: "email" }, [
                    _createTextVNode("Adresse Email "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ])
              ]),
              (!!errors['email'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(errors['email']), 1))
                : _createCommentVNode("", true)
            ])
          ])),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, " ", -1)),
      _createElementVNode("div", _hoisted_32, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_custom_button, {
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Valider", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1))
    ])
  ]))
}
}

})